module.exports = __webpack_public_path__ + "static/media/share.7c72ed02.svg";